import { Chassis } from '../../scene/Chassis';
import { useBodyPalette } from '../../scene/BodyFinish';
import { GLASS, HEADLIGHT, TAIL_LIGHT } from '../../scene/materials';
import { WATER_TANKER } from './dimensions';

const WaterTankerBody = () => {
  const palette = useBodyPalette('water_tanker');
  const { tank } = WATER_TANKER;
  return <group>
    <Chassis>
      <mesh position={[-0.2, 0.98, 0]}>
        <boxGeometry args={[7.45, 0.28, 0.25]} />
        <meshPhysicalMaterial {...palette.chassis} />
      </mesh>
      {[-1, 1].map((side) => <mesh key={`rail-${side}`} position={[-0.2, 1.12, side * 0.86]}>
        <boxGeometry args={[7.5, 0.18, 0.13]} />
        <meshPhysicalMaterial {...palette.chassis} />
      </mesh>)}
    </Chassis>

    <mesh position={[2.3, 1.78, 0]}>
      <boxGeometry args={[1.65, 1.55, 2.28]} />
      <meshPhysicalMaterial {...palette.body} />
    </mesh>
    <mesh position={[3.16, 2.1, 0]}>
      <boxGeometry args={[0.05, 0.5, 1.68]} />
      <meshPhysicalMaterial {...GLASS} />
    </mesh>
    {[-1, 1].map((side) => <mesh key={`window-${side}`} position={[2.4, 2.12, side * 1.15]}>
      <boxGeometry args={[0.86, 0.48, 0.025]} />
      <meshPhysicalMaterial {...GLASS} />
    </mesh>)}
    <mesh position={[3.24, 1.14, 0]}>
      <boxGeometry args={[0.14, 0.3, 2.42]} />
      <meshPhysicalMaterial {...palette.edge} />
    </mesh>
    {[-1, 1].map((side) => <mesh key={`headlight-${side}`} position={[3.29, 1.34, side * 0.72]}>
      <boxGeometry args={[0.08, 0.17, 0.28]} />
      <meshPhysicalMaterial {...HEADLIGHT} />
    </mesh>)}

    <mesh position={[tank.centreX, tank.centreY, 0]} rotation={[0, 0, Math.PI / 2]}>
      <cylinderGeometry args={[tank.radius, tank.radius, tank.length, 40]} />
      <meshPhysicalMaterial {...palette.secondary} />
    </mesh>
    {[-1.7, -0.2, 1.3].map((offset) => <mesh key={`tank-band-${offset}`} position={[tank.centreX + offset, tank.centreY, 0]} rotation={[0, 0, Math.PI / 2]}>
      <torusGeometry args={[tank.radius + 0.025, 0.045, 12, 36]} />
      <meshPhysicalMaterial {...palette.edge} />
    </mesh>)}
    <mesh position={[tank.centreX - 1.0, tank.centreY + tank.radius + 0.12, 0]}>
      <boxGeometry args={[0.9, 0.08, 0.18]} />
      <meshPhysicalMaterial {...palette.edge} />
    </mesh>
    <mesh position={[-3.38, 1.1, 0]}>
      <boxGeometry args={[0.1, 0.16, 2.15]} />
      <meshPhysicalMaterial {...palette.chassis} />
    </mesh>
    {[-1, 1].map((side) => <mesh key={`tail-light-${side}`} position={[-3.45, 1.2, side * 0.82]}>
      <boxGeometry args={[0.08, 0.18, 0.24]} />
      <meshPhysicalMaterial {...TAIL_LIGHT} />
    </mesh>)}
  </group>;
};

export { WaterTankerBody };
